module.exports = __webpack_public_path__ + "img/car_00067.276fa2d8.jpg";